import { isoZ, z } from 'my-zod'
import { PromotionSchemas } from '..'

export const affiliatesModel = z.object({
  id: z.string(),
  shortId: z.string().nullable(),
  name: z.string(),
  phone: z.string().nullable(),
  email: z.string().email('Invalid email format'),
  operatorId: z.number().int().nullable(),
  addressId: z.string().nullable(),
  commissionPercent: z.number().nullable(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type affiliatesModel = z.infer<typeof affiliatesModel>

export const updateAffiliateModel = z.object({
  name: z.string().min(1),
  phone: z.string().nullable(),
  email: z.string().email('Invalid email format'),
  commissionPercent: z
    .number()
    .min(0, { message: 'Commission percent must be at least 0%' })
    .max(100, { message: 'Commission percent must be at most 100%' }),
  address: z
    .object({
      addressLine1: z.string().min(1),
      addressLine2: z.string().nullable(),
      city: z.string().min(1),
      stateProvince: z.string().min(1),
      postalCode: z.string().min(1),
      country: z.string().min(1)
    })
    .nullable(),

  selectedPromotions: z.array(PromotionSchemas.promotionModel)
})
